import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderElementComponent} from './header-element/header-element.component';

@NgModule({
	declarations: [
		HeaderElementComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		HeaderElementComponent
	]
})
export class StructElementsModule {}
